// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2LCX3","error":"Textarea_error__3Bj9n","readonly":"Textarea_readonly__sqZh8","disabled":"Textarea_disabled__GhgPo"};